// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__PBKWm","medium":"Logo_medium__1i6fL"};